import ReactDOM from "react-dom";
import {ToastContainer} from "react-toastify";
import React from "react";
import 'react-toastify/dist/ReactToastify.min.css';

ReactDOM.render(<ToastContainer
    theme="colored"
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    style={{maxWidth: "600px", width: "80%", minWidth: "200px"}}
/>, document.getElementById('toast-container'));
